function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true})

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
            
            if (isOpen) {
              document.querySelector('sticky-header').classList.remove('menu-opening');
            } else {
              document.querySelector('sticky-header').classList.add('menu-opening');
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');
            this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
            });
        }
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent() {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('ul');
        this.sliderItems = this.querySelectorAll('li');
        this.pageCount = this.querySelector('.slider-counter--current');
        this.pageTotal = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');


        if (!this.slider || !this.nextButton) return;

        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));


    }

    initPages() {
        const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
        if (sliderItemsToShow.length === 0) return;
        this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
        this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();

    }

    update() {


        if (!this.pageCount || !this.pageTotal) return;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

        if (this.currentPage === 1) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.currentPage === this.totalPages) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
        

        this.pageCount.textContent = this.currentPage;
        this.pageTotal.textContent = this.totalPages;

        $('.product__media-item.zoom_disabled').removeClass('active');
        $('.product__media-item.zoom_disabled[data-loop-id=' + this.currentPage + ']').addClass('active');

        /*custom code for scrolling*/
        var thumbPositions = [];
        $('.product__media-list.thumbs .product__media-item').each(function (index) {
            thumbPositions[index + 1] = $(this).position().left;
        })
        var thumbsWidth = $(".product__media-list.thumbs").width();


        $('.product__media-list.thumbs').scrollLeft(thumbPositions[this.currentPage]);


    }

    onButtonClick(event) {
        event.preventDefault();
        const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {

        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const newMedia = document.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        console.log(12234);

        if (!newMedia) return;
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        modalContent.prepend(newMediaModal);
        parent.prepend(newMedia);
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (this.stickyHeader) {
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
        window.setTimeout(() => {
            parent.scrollLeft = 0;
            parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
        });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')                
                // const destination = document.getElementById(id);
                const destination = document.querySelectorAll('.'+id);
                // const source = html.getElementById(id);
                const source = html.querySelectorAll('.'+id)[0];

                // console.log(id)
                // console.log(html)
                // console.log(destination)
                console.log(source)


                if (source && destination) {

                    // destination.innerHTML = source.innerHTML;
                    for (var i = 0; i < destination.length; ++i) {
                      destination[i].innerHTML = source.innerHTML;
                    }
                }

                // const price = document.getElementById(`price-${this.dataset.section}`);
                const price = document.querySelectorAll('.'+`price-${this.dataset.section}`)[0];
                
                console.log(price)

                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);


class AgeGate extends HTMLElement {

    constructor() {
        super();
        // this.$page = $('#MainContent');
        this.$body = $('body');
        this.$ageGate = $('.js-age-gate');
        this.$yes = $('.js-age-gate-yes');
        this.$no = $('.js-age-gate-no');

        this.addClickHandlers();
        this.initialize();
        // this.init();
    }

    addClickHandlers() {
        this.$yes.on('click', (event) => {
            event.preventDefault();
            this.setAgeOver21();
            this.showPage();
        });

        this.$no.on('click', (event) => {
            event.preventDefault();
            window.location.href = 'https://www.responsibility.org';
        });
    }

    initialize() {
        this.checkIfOver21();
    }

    checkIfOver21() {
        if (this.isOver21() == true) {
            // this.showPage();
        } else {
            this.showAgeGate();
        }
    }

    showPage() {
        this.$body.removeClass('inactive');
        Modal($('#age-gate'))
    }

    showAgeGate() {
        this.$body.addClass('inactive');
        Modal($('#age-gate'))
    }

    setAgeOver21() {
        const EXP_TIME = 30; // 30 days
        this.setCookie('capemay-agegate', true, EXP_TIME)
    }

    isOver21() {
        if (window.location.href.indexOf('oseid') > 0) {
            return true;
        }
        return this.getCookie('capemay-agegate');
    }

    setCookie(cookie, value, expiry) {
        const date = new Date();
        date.setTime(date.getTime() + (expiry * 24 * 60 * 60 * 1000));
        var expires = "expires="+date.toUTCString();
        document.cookie = cookie + "=" + value + ";" + expires + ";path=/";
    }

    getCookie(cookie) {
        let name = cookie + "=";
        let spli = document.cookie.split(';');
        for(var j = 0; j < spli.length; j++) {
            let char = spli[j];
            while (char.charAt(0) == ' ') {
                char = char.substring(1);
            }
            if (char.indexOf(name) == 0) {
                return true;
            }
        }
        return false;
    }

}

customElements.define('age-gate', AgeGate);


// export default AgeGate;


function watchForElement(el, method) {
    chkDelay = '200'; // Amount of time between Checks
    var chkExist = setInterval(function () {
        chkClass = $(el);
        if (chkClass.length) {
            // DO something
            clearInterval(chkExist);
            method(chkClass)
        }
    }, chkDelay);
}

// var chkEl = '[data-testid="ShopifyPay-button"]';
// watchForElement(chkEl,function(el) {
//   el.parent().hide()
// })


watchForElement('#shopify-section-header', function (el) {
    updateHeightVar('#shopify-section-header', '--header-height')
})
watchForElement('#shopify-section-announcement-bar', function (el) {
    updateHeightVar('#shopify-section-announcement-bar', '--announce-height')
})

function updateHeightVar(el, v) {
    let prevH;
    let itm = document.querySelector(el);

    initH()

    window.addEventListener('resize', runTwice);
    window.addEventListener('scroll', runTwice);

    function runTwice() {
        initH()
        setTimeout(function () {
            initH()
        }, 100)
    }

    function initH() {
        var H = itm.clientHeight;
        if (H != prevH) {
            // console.log('run')
            // Then we set the value in the --header-height custom property to the root of the document
            document.documentElement.style.setProperty(v, `${H}px`);
            prevH = H;
        }
    }
}

function Modal(el) {
    el = el;
    act = 'active';
    actMod = 'modal-active';
    initMdl(el)

    function initMdl(el) {
        winWidth = $(window).width();
        thisEl = el;
        type = getDataName($(thisEl)).length ? getDataName($(thisEl)) : 'modal';
        thisMdl = getDataName($(thisEl)).length ? $('[data-modal="' + $(thisEl).data(type) + '"]') : $(thisEl);
        if (type == 'open' || type == 'modal') {
            if (!thisMdl.is('.' + act)) {
                showModal(thisMdl);
            } else {
                hideModal(thisMdl);
            }
        }
        if (type == 'close') {
            hideModal(thisMdl);
        }
    }

    function showModal(el) {
        var lastTop = $(window).scrollTop(),
            el = $(el),
            delay = 0;
        $('body').addClass(actMod).css({top: -lastTop});
        if (el.is('[style*=display]')) {
            el[0].removeAttribute('style');
            delay = 100; // gives a moment for animation settings to take over
        }
        setTimeout(function () {
            el.addClass(act);
            el.find(':focusable').first().focus();
        }, delay)
    }

    function hideModal(el) {
        var lastTop = Math.abs(parseInt($('body').css('top'))),
            el = $(el);
        $('body').css({top: 0}).removeClass(actMod);
        window.scrollTo(0, lastTop);
        el.removeClass(act);
    }

    function getDataName(node) {
        var d = {},
            key = '',
            re_dataAttr = /^data\-(.+)$/;
        $.each(node.get(0).attributes, function (index, attr) {
            if (re_dataAttr.test(attr.nodeName)) {
                key = attr.nodeName.match(re_dataAttr)[1];
            }
        });
        return key;
    }
}


waitFor_jQuery(function () {


    jQuery.extend(jQuery.expr[':'], {
        focusable: function (el, index, selector) {
            return $(el).is('a, button, :input, label, [tabindex]');
        }
    });


    // Accordian
    $('#tabs-select').on('change', function () {
        var url = $(this).val(); // get selected value
        if (url) { // require a URL
            // window.location = url; // redirect
            $('a[href="' + url + '"]').trigger('click');
        }
        return false;
    });

    // sidebar links
    $('.accordion-section .sidebar-link').on('click  touch', function () {
        // body...
        $('.accordion-section .sidebar-link').removeClass('active');
        $(this).addClass('active');
    })
    // Accordian
    $(document).on('touch click', '.acc-btn', function () {
        var btn = '.acc-btn',
            animTime = 300,
            justClickedDelay = 500,
            justClicked = false,
            active = 'selected',
            cont = '.acc-content',
            ttlTxt = 'h3',
            imgItm = '.img',
            clckdIndx = $(this).index(btn),
            inrChldHght = $(cont).children().eq(clckdIndx).outerHeight(),
            $thsTtl = $(this).find(ttlTxt),
            $thsImg = $(this).find(imgItm),
            isOpen = $thsTtl.hasClass(active),
            winWidth = $(window).width(),
            clearItem = $('#shopify-section-header'),
            actTab = $(ttlTxt + '.' + active),
            actTabTop = !!actTab ? '' : actTab[0].getBoundingClientRect().top + window.scrollY;
        if (!!clearItem && !!actTab) {
            actTabTop = actTabTop + clearItem.outerHeight(true) + 15;
        }
        if (!justClicked) {
            justClicked = true;
            if (isOpen) {
                removeClasses();
                openClose();
                // console.log('close')
            } else {
                // console.log('open')
                removeClasses();
                addClasses();
                openClose(true);
                // mobScroll();
            }
            setTimeout(function () {
                justClicked = false;
            }, justClickedDelay);
        }

        function mobScroll() {
            if (winWidth < 750) {
                setTimeout(function () {
                    console.log(openTabDist)
                    $([document.documentElement, document.body]).animate({
                        scrollTop: openTabDist
                    }, animTime);
                }, animTime * 2.5);
            }
        }

        function removeClasses() {
            $(btn + ' ' + ttlTxt).removeClass(active);
            $(btn + ' ' + imgItm).removeClass(active);
        }

        function addClasses() {
            $thsTtl.addClass(active);
            $thsImg.addClass(active);
        }

        function zeroHght() {
            $(cont).stop().animate({height: 0}, animTime);
        }

        function setHght() {
            $(cont).eq(clckdIndx).stop().animate({height: inrChldHght}, animTime);
        }

        function openClose(dir) {
            if (dir == 'open' || dir == true) {
                zeroHght()
                setHght()
            } else {
                setHght()
                zeroHght()
            }
        }
    });


    // on load
    thisHash = window.location.hash;
    clearThis = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height() + 25;

    // removes hash from href
    // history.pushState(thisHash, '', window.location.pathname);
    if (thisHash.length > 0) {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $(thisHash).offset().top - clearThis
            }, 1000);
        }, 200)
    }
    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#recover"]')
        .not('[href="#login"]')
        .not('[href="#0"]')
        .click(function (event) {

            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - clearThis
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                        ;
                    });
                }
            }
        });


    var actLogin = 'active';
    if (thisHash.length > 0 && thisHash == '#recover') {
        $('.' + actLogin).removeClass(actLogin);
        $(thisHash).addClass(actLogin);
    }
    $('[href="#recover"],[href="#login"]').click(function (e) {
        e.preventDefault()
        var tar = $(this).attr('href');
        $('.' + actLogin).removeClass(actLogin);
        $(tar).addClass(actLogin);
    })

    $('a')
        .not('#boldmetrics-ssc-activator')
        .not('.img-tab-link-2') // .not() ignores anchors with this class
        .not('[href*="tel:"]')
        .not('[href*="mailto:"]')
        .not('.product-single__thumbnail')
        .not('[href="#recover"]')
        .not('[href="#login"]')
        .each(function () {
            var a = new RegExp('/' + window.location.host + '/');
            if (!a.test(this.href)) {
                $(this).click(function (event) {
                    if (!$(this).is('#boldmetrics-ssc-activator')) {
                        event.preventDefault();
                        event.stopPropagation();
                        window.open(this.href, '_blank');
                    }
                });
            }
        });

    $('#boldmetrics-ssc-activator').click(function (event) {
        event.preventDefault();
        event.stopPropagation();
    });


    // show/hide back to top
    backToTop()

    $(document).scroll(function () {
        backToTop()
    });
    $(document).resize(function () {
        backToTop()
    });

    function backToTop() {
        var topBtn = $('.back-to-top'),
            act = 'show-top',
            fromTop = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop,
            minDist = window.innerHeight * 0.75;
        if (fromTop > minDist) {
            topBtn.addClass(act)
        } else {
            topBtn.removeClass(act)
        }
    }


    $('.js-filters-toggle').click(function (e) {
        $('html').toggleClass('filters-is-open');
        e.preventDefault();
    });


    $(document).ready(function () {
        $('.modal-action').on('click touch', function (e) {
            e.preventDefault();
            Modal($(this));
            // console.log($(this))

            var vid = $(this).closest('.video-modal').find('iframe');
            if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
                var vidSrc = vid.attr('src');
                // console.log(vidSrc)
                vid.attr('src', vidSrc);
            }
        })


        $('.btn-modal').on('click touch', function () {

            var thsId = $(this).attr('href');

            Modal($(thsId));
            // console.log($(thsId))

            var vid = $(thsId).find('iframe');
            if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
                var vidSrc = vid.attr('src');
                // console.log(vidSrc)
                vid.attr('src', vidSrc);
            }
        })
    })

    videoRatio()

    function videoRatio() {
        var vid = $('.video-ratio:not(.for-modal) iframe, .video-ratio:not(.for-modal) video');

        initRatio();
        $(window).resize(function () {
            initRatio();
        })

        function initRatio() {
            var winWdth = $(window).width(),
                ratio = 0.56;

            if (vid.length) {
                vid.each(function () {
                    var thsVid = $(this);

                    if (typeof thsVid.data('video-ratio') !== 'undefined') {
                        var ratio = thsVid.data('video-ratio');
                    }
                    var thsVidPar = thsVid.closest('div'),
                        thsVidParHght = thsVidPar.outerHeight(true),
                        cssHght = thsVidParHght,
                        cssWdth = cssHght / ratio;

                    if (cssWdth < winWdth) {
                        var cssWdth = winWdth,
                            cssHght = cssWdth * ratio;
                    }

                    thsVid.attr('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')

                })
            }
        }
    }

});
  

